// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'

import CategoryHeadingModule from '@uswitch/ev-components/lib/components/compounds/category'
import Breadcrumbs from './breadcrumbs.connected'
import connect from '@h/connect-redux'
import { getModuleFromIncludes, includes } from '@r/contentful-selectors'
import { contentId } from '@u/contentful'
import ImgixImg from '@h/imgix-image'

const Figure = (props) => {
  const breadcrumbs = props.breadcrumbs && <Breadcrumbs entity={props.breadcrumbs} />
  const Image = props.image && (
    <ImgixImg
      src={props.image?.file?.url}
      alt={props.image?.title}
      sx={{
        maxHeight: '180px',
        display: 'block',
        marginLeft: 'auto',
        marginRight: ['auto', 0],
      }}
    />
  )

  return (
    <CategoryHeadingModule
      {...props}
      breadcrumbs={breadcrumbs}
      image={Image}
      icon='info'
      iconColor='opaque-white-01'
    />
  )
}

export default connect((state, props) => {
  const image = getModuleFromIncludes(includes(state), contentId(props.image)).fields
  return { image }
})(Figure)
